// team/shared/components/button/TeamIosDarkToggle.js
import React from 'react';
import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

/**
 * iOS-style dark toggle switch component
 * Black when checked, gray when unchecked
 * Using styled component for better CSS specificity (like MUI's official example)
 */
const IOSDarkSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(() => ({
    width: 40,
    height: 20,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2, // 20px track - 16px thumb = 4px, so 2px margin on each side centers it vertically
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(20px)', // Horizontal movement only, margin handles vertical centering
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#000000', // Black when checked (iOS dark mode style)
                opacity: 1,
                border: 'none',
            },
        },
        '&.Mui-disabled': {
            '& + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 16,
        height: 16,
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        backgroundColor: '#fff',
    },
    '& .MuiSwitch-track': {
        borderRadius: 20 / 2,
        backgroundColor: '#E5E5EA', // iOS gray when unchecked
        opacity: 1,
        transition: 'background-color 0.2s ease',
    },
}));

const TeamIosDarkToggle = ({ checked, onChange, disabled = false, sx = {}, ...otherProps }) => {
    return (
        <IOSDarkSwitch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            sx={sx}
            {...otherProps}
        />
    );
};

TeamIosDarkToggle.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    sx: PropTypes.object,
};

export default TeamIosDarkToggle;

